import { useMemo } from 'react';

export const useJobsConfig = () => {
  const jobsRoot = document.getElementById('portal-job-detail-root');

  return useMemo(
    () => ({
      imagesApi: jobsRoot?.dataset.imagesApi ?? '',
      jobImageCount: Number(jobsRoot?.dataset.jobImageCount ?? 0),
      weighingImageCount: Number(jobsRoot?.dataset.weighingImageCount ?? 0),
    }),
    [jobsRoot?.dataset.imagesApi, jobsRoot?.dataset.jobImageCount, jobsRoot?.dataset.weighingImageCount]
  );
};
